<template>
    <div class="account">
      <div class="field">
          <div class="control">
              <div class="columns">
                  <div class="column ">
                      <span>Your picture is mandatory to receive assignments. Please upload a picture (.jpg or .png) of yourself by clicking on "<strong>Upload Profile Image</strong>" below. For best quality, make sure the image dimension is square, e.g. 500px by 500px.</span><br/><br/>
                      <div class='formfield'>
                          <div class='account-user-image'>
                              <a :href="profileImageUrl" target="_blank"><img :src="profileImageUrl" /></a>
                              <div style="margin-top: 24px;">
                              <file-uploader :vuexStore="fileUploadStore" :vuexSelectAction="fileSelectAction" :vuexUploadAction="fileUploadAction" :setDescription="setDescription" :buttonName="buttonName"></file-uploader>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            fileUploadStore: 'user',
            fileSelectAction: 'canUploadFile',
            fileUploadAction: 'uploadUserProfile',
            buttonName: 'Upload Profile Image',
            setDescription: false,
            firstNameErr: false,
            lastNameErr: false,
            emailErr: false,
            passwordErr: false,
            userNameErr: false,
            cellPhoneErr: false
        }
    },

    computed: {
        ...mapGetters('user', {
            profileImageUrl: 'getProfileImageUrl',
            user: 'getFormData'
        }),

        ...mapGetters('vendors', {
            formData: 'getFormData'
        }),

        ...mapState('profile', {
            canSave: state => state.canSave,
            isLoading: state => state.isLoading,
            password: state => state.password,
            successMessage: state => state.successMessage,
            showSuccess: state => state.showSuccess,
            savingError: state => state.savingError,
            errorMessage: state => state.errorMessage,
        }),
    },

    methods:{
    },

    created(){
    },

    mounted(){
    },
}
</script>

<style>
.account-user-image img{
    width: 150px;
    height: 150px;
    margin-top: 3px;
    border-radius: 50%;
}
</style>
